import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { NewsFeedItemSingleViewComponent } from '@fi-app/news-feed/news-feed-item-single-view/news-feed-item-single-view.component';
import { NewsFeedService } from '@fi-app/news-feed/news-feed.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { ForumService } from '@fi-app/forum/forum.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { IObjectDto } from '@fi-shared/models/models';

export const FiPostViewState: Ng2StateDeclaration = {
    name: FiStateNames.PostView,
    url: '/PostView/:objectId/:objectType?forumId&commentId&groupId&highlightText&focusNewComment',
    component: NewsFeedItemSingleViewComponent,
    reloadOnSearch: false,
    resolve: {
        newsFeedItem: [NewsFeedService, FiStateService, Transition, FiPostViewStateResolve_newsFeedItem],
        forum: [ForumService, FiStateService, Transition, FiPostViewStateResolve_forum],
        highlightText: [FiStateService, Transition, FiPostViewStateResolve_highlightText],
        pageTitle: [PageTitleService, FiPostViewStateResolve_pageTitle],
        focusNewComment: [FiStateService, Transition, FiPostViewStateResolve_focusNewComment],
        commentId: [FiStateService, Transition, FiPostViewStateResolve_commentId],
    },
};

export function FiPostViewStateResolve_newsFeedItem(
    newsFeedService: NewsFeedService,
    fiStateService: FiStateService,
    tr: Transition,
) {
    const $stateParams = fiStateService.getParams(tr);
    return new Promise((resolve, reject) => {
        if (!$stateParams.groupId) {
            const idTypeData: IObjectDto = {
                ObjectId: $stateParams.objectId,
                ObjectType: $stateParams.objectType,
            };

            newsFeedService
                .GetNewsFeedsByIdType([idTypeData])
                .then((items) => {
                    if (items.length > 0) {
                        resolve(items[0]);
                    } else {
                        reject();
                    }
                })
                .catch(reject);
        } else {
            newsFeedService
                .GetNewsFeedsByGroupId($stateParams.groupId)
                .then((items) => {
                    if (items.length > 0) {
                        resolve(items[0]);
                    } else {
                        reject();
                    }
                })
                .catch(reject);
        }
    });
}

export function FiPostViewStateResolve_forum(forumService, fiStateService: FiStateService, $transition$: Transition) {
    const $stateParams = fiStateService.getParams($transition$);
    if ($stateParams.forumId) return forumService.getForum($stateParams.forumId);

    return Promise.resolve(null);
}

export function FiPostViewStateResolve_highlightText(fiStateService: FiStateService, $transition$: Transition) {
    return fiStateService.getParams($transition$).highlightText;
}

export function FiPostViewStateResolve_focusNewComment(fiStateService: FiStateService, $transition$: Transition) {
    return fiStateService.getParams($transition$).focusNewComment;
}

export function FiPostViewStateResolve_commentId(fiStateService: FiStateService, $transition$: Transition) {
    return fiStateService.getParams($transition$).commentId;
}

export function FiPostViewStateResolve_pageTitle(ccmPageTitle) {
    return ccmPageTitle.setTitle('Post View');
}
